import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import rp from '@reporting/rp-app-host';

export class FolderFormAdapter extends FormAdapter {

	constructor(
		private a: number,
		private lang: string,
		public path: string = null
	) { super() }

	getColumns() {
		return [
			{width: 100},
			{width: null},
		];
	}

	async getControls() {
		const rows = [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Path'), for: 'newPath'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'newPath', value: this.path, required: true},
		];
		return rows;
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [
				"save",
				"close"
			]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		const options = {
			lang: this.lang,
			path: this.path,
			newPath: formValues.newPath as string
		}
		await rp.ms('wiki').patch(`renameFolder`, options, { accounting: this.a });
		return true;
	}

};
